(ns frontend.components.shortcut-help
  "Shortcut help"
  (:require [frontend.components.shortcut :as shortcut]
            [frontend.context.i18n :refer [t]]
            [frontend.extensions.highlight :as highlight]
            [frontend.extensions.latex :as latex]
            [logseq.common.util.block-ref :as block-ref]
            [logseq.common.util.page-ref :as page-ref]
            [logseq.shui.ui :as shui]
            [io.factorhouse.hsx.core :as hsx]))

(hsx/defc trigger-table []
  [:table.classic-table.w-full
   [:thead
    [:tr
     [:th.text-left [:b (t :help.shortcuts/triggers)]]
     [:th.text-right [:b (t :help.shortcuts/shortcut-column)]]]]
   [:tbody
    [:tr
     [:td.text-left (t :help/slash-autocomplete)]
     [:td.text-right [:code "/"]]]
    [:tr
     [:td.text-left (t :help/search)]
     [:td.text-right [:div.float-right
                      (shui/shortcut ["mod" "k"])]]]
    [:tr
     [:td.text-left (t :help/reference-autocomplete)]
     [:td.text-right [:code page-ref/left-and-right-brackets]]]
    [:tr
     [:td.text-left (t :help/block-reference)]
     [:td.text-right [:code block-ref/left-and-right-parens]]]
    [:tr
     [:td.text-left (t :help/open-link-in-sidebar)]
     [:td.text-right [:code (t :help/open-link-in-sidebar-action)]]]
    [:tr
     [:td.text-left (t :help/context-menu)]
     [:td.text-right [:code (t :help/context-menu-action)]]]]])

(defn markdown-syntax []
  (let [list [:bold :italics :del :mark :math :latex :code :link :pre :img]
        title (t :help/markdown-syntax)
        learn-more "https://www.markdownguide.org/basic-syntax"
        raw {:bold (str "**" (t :format/bold) "**")
             :italics (str "_" (t :format/italics) "_")
             :link "[Link](https://www.example.com)"
             :del (str "~~" (t :format/strikethrough) "~~")
             :mark (str "^^" (t :format/highlight) "^^")
             :math (str (t :help/inline-math-example-prefix) " $E = mc^2$")
             :latex "$$E = mc^2$$"
             :code (str "`" (t :format/code) "`")
             :pre "```clojure\n  (println \"Hello world!\")\n```"
             :img "![image](https://asset.logseq.com/static/img/logo.png)"}

        rendered {:italics [:i (t :format/italics)]
                  :bold [:b (t :format/bold)]
                  :link [:a {:href "https://www.example.com"} (t :ui/link)]
                  :del [:del (t :format/strikethrough)]
                  :mark [:mark (t :format/highlight)]
                  :math [:span (t :help/inline-math-example-prefix) " " (latex/latex "E = mc^2" false false)]
                  :latex (latex/latex "E = mc^2" true false)
                  :code [:code (t :format/code)]
                  :pre (highlight/highlight "help-highlight" {:data-lang "clojure"} "(println \"Hello world!\")")
                  :img [:img {:style {:float "right" :width 32 :height 32}
                              :src "https://asset.logseq.com/static/img/logo.png"
                              :alt (t :ui/image)}]}]

    [:table.classic-table.w-full
     [:thead
      [:tr
       [:th.text-left [:b title]]
       [:th.text-right [:a {:href learn-more} (str (t :help/learn-more) " →")]]]]
     [:tbody
      (map (fn [name]
             [:tr
              [:td.text-left [(if (= :pre name) :pre :code) (get raw name)]]
              [:td.text-right (get rendered name)]])
           list)]]))

(hsx/defc shortcut-page
  [{:keys [show-title?]
    :or {show-title? true}}]
  [:div.cp__shortcut-page.px-2
   {:class "-mt-2"}
   (when show-title? [:h1.title (t :help.shortcuts/title)])
   (trigger-table)
   (markdown-syntax)
   (shortcut/shortcut-keymap-x)])
